import * as angular from "angular";
import {IController} from "angular";
import {ServiceType} from "../../../deliveries/types/service.type";
import {HolderType} from "../../../commons/types/holder.type";
import * as _ from "lodash"
import {DocumentSettings} from "../../models/document-settings.model";
import {ReminderSettings} from "../../models/reminder-settings.model";
import {AbsenceReasonSettings} from "../../models/absence-reason-settings.model";
import {BreakType} from "../../models/break-type.model";
import {AbsenceReasonsDialogsService} from "../../services/absence-reasons-dialogs.service";
import {BreakTypesDialogsService} from "../../services/break-types-dialogs.service";
import {DocumentsDialogsService} from "../../services/documents-dialogs-service.service";
import {RemindersDialogsService} from "../../services/reminders-dialogs-service.service";
import {SettingsService} from "../../services/settings-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class AgentsPreferencesTabCtrl implements IController {
  documents: DocumentSettings[] = [];
  reminders: ReminderSettings[] = [];
  absenceReasons: AbsenceReasonSettings[] = [];
  breakTypes: BreakType[] = [];

  public serviceTypes: ServiceType[];
  public isTimekeepingEnabled: boolean;
  private selectedTab: any;

  /* @ngInject */
  constructor(private documentsDialogsService: DocumentsDialogsService, private remindersDialogsService: RemindersDialogsService, private absenceReasonsDialogsService: AbsenceReasonsDialogsService,
              private breakTypesDialogsService: BreakTypesDialogsService,
              private $log, private confirmDialogService: ConfirmDialogService, private settingsService: SettingsService,
              private splitService: SplitService) {
  }

  $onInit() {
    this.selectedTab = 0; // 0 = General, 1 = Additions
    this.isTimekeepingEnabled = this.splitService.isTimekeepingEnabled();
  }

  // ******************************
  //        Public Methods
  // ******************************

  onTabSelect(selectedTab) {
    this.selectedTab = selectedTab;
  }

  ////////////////////////////////////// DOCUMENTS //////////////////////////////////////

  onCreateDocument(event) {
    this.documentsDialogsService.createDocument(event, HolderType.AGENT)
      .then(({document}) => {
        return this.settingsService.createDocument(document)
      })
      .then((createdDocument) => {
        this.documents.push(createdDocument);
      })
      .catch(() => {
        this.$log.info('Failed to create document')
      })
  }

  onEditDocument(event, documentId) {
    const document = _.find(this.documents, (doc) => {
      return doc.id === documentId;
    })
    const documentCopy = angular.copy(document)
    this.documentsDialogsService.editDocument(event, documentCopy)
      .then(({document}) => {
        return this.settingsService.updateDocument(document)
      })
      .then((updatedDocument) => {
        const index = _.findIndex(this.documents, {id: documentId});
        this.documents.splice(index, 1, updatedDocument);
      })
      .catch(() => {
        this.$log.info('Failed to edit document')
      })
  }

  onDeleteDocument(event, document) {
    const title = 'Delete Document';
    const body = 'Are you sure you want to delete this document?';

    this.confirmDialogService.confirm(title, body, event)
      .then(() => {
        const documentCopy = angular.copy(document);
        return this.settingsService.deleteDocument(documentCopy)
      })
      .then(() => {
        const index = _.findIndex(this.documents, {id: document.id})
        this.documents.splice(index, 1);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  ////////////////////////////////////// REMINDERS //////////////////////////////////////


  onCreateReminder(event) {
    this.remindersDialogsService.createReminder(event, HolderType.AGENT)
      .then(({reminder}) => {
        return this.settingsService.createReminder(reminder)
      })
      .then((createdReminder) => {
        this.reminders.push(createdReminder);
      })
      .catch(() => {
        this.$log.info('Failed to create reminder')
      })
  }

  onEditReminder(event, reminderId) {
    const reminder = _.find(this.reminders, (rem) => {
      return rem.id === reminderId;
    })
    const reminderCopy = angular.copy(reminder)
    this.remindersDialogsService.editReminder(event, reminderCopy)
      .then(({reminder}) => {
        return this.settingsService.updateReminder(reminder)
      })
      .then((updatedReminder) => {
        const index = _.findIndex(this.reminders, {id: reminderId});
        this.reminders.splice(index, 1, updatedReminder);
      })
      .catch(() => {
        this.$log.info('Failed to edit reminder')
      })
  }

  onDeleteReminder(event, reminder) {
    const title = 'Delete reminder';
    const body = 'Are you sure you want to delete this reminder?';

    this.confirmDialogService.confirm(title, body, event)
      .then(() => {
        const reminderCopy = angular.copy(reminder);
        return this.settingsService.deleteReminder(reminderCopy)
      })
      .then(() => {
        const index = _.findIndex(this.reminders, {id: reminder.id})
        this.reminders.splice(index, 1);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  ////////////////////////////////////// ABSENCE REASONS //////////////////////////////////////

  onCreateAbsenceReason(event) {
    this.absenceReasonsDialogsService.createAbsenceReason(event)
      .then((absenceReason) => {
        return this.settingsService.createAbsenceReason(absenceReason)
      })
      .then((createdAbsenceReason) => {
        this.absenceReasons.push(createdAbsenceReason);
      })
      .catch(() => {
        this.$log.info('Failed to create absence reason')
      })
  }

  onEditAbsenceReason(event, absenceReason: AbsenceReasonSettings) {
    const absenceReasonCopy = angular.copy(absenceReason);

    this.absenceReasonsDialogsService.editAbsenceReason(event, absenceReasonCopy)
      .then(absenceReason => {
        return this.settingsService.updateAbsenceReason(absenceReason);
      })
      .then((editedAbsenceReason) => {
        const index = _.findIndex(this.absenceReasons, {id: absenceReason.id});
        this.absenceReasons[index] = editedAbsenceReason;
      })
      .catch(() => {
        this.$log.info('Failed to edit absence reason')
      })
  }

  onDeleteAbsenceReason(event, absenceReasonId) {
    const title = 'Delete Absence Reason';
    const body = 'Are you sure you want to delete this absence reason?';

    this.confirmDialogService.confirm(title, body, event)
      .then(() => {
        return this.settingsService.deleteAbsenceReason(absenceReasonId)
      })
      .then(() => {
        const index = _.findIndex(this.absenceReasons, {id: absenceReasonId})
        this.absenceReasons.splice(index, 1);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  ////////////////////////////////////// BREAK TYPES //////////////////////////////////////

  onCreateBreakType(event) {
    this.breakTypesDialogsService.createBreakType(event)
      .then((breakType: BreakType) => {
        return this.settingsService.createBreakType(breakType);
      })
      .then((createdBreakType: BreakType) => {
        this.breakTypes.push(createdBreakType);
      })
      .catch(() => {
        this.$log.info('Failed to create break type');
      });
  }

  onEditBreakType(event, breakType: BreakType) {
    const breakTypeCopy = angular.copy(breakType);

    this.breakTypesDialogsService.editBreakType(event, breakTypeCopy)
      .then((updated: BreakType) => {
        return this.settingsService.updateBreakType(updated);
      })
      .then((updatedBreakType: BreakType) => {
        const index = _.findIndex(this.breakTypes, {id: breakType.id});
        this.breakTypes.splice(index, 1, updatedBreakType);
      })
      .catch(() => {
        this.$log.info('Failed to edit break type');
      });
  }

  onDeleteBreakType(event, breakType: BreakType) {
    const title = 'Delete Break Type';
    const body = 'Are you sure you want to delete this break type?';

    this.confirmDialogService.confirm(title, body, event)
      .then(() => {
        return this.settingsService.deleteBreakType(breakType.id);
      })
      .then(() => {
        const index = _.findIndex(this.breakTypes, {id: breakType.id});
        this.breakTypes.splice(index, 1);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      });
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('agentsPreferencesTab', {
    bindings: {
      documents: '<',
      reminders: '<',
      absenceReasons: '<',
      breakTypes: '<'
    },
    template: require('./agents-preferences-tab.html').default,
    controller: AgentsPreferencesTabCtrl
  });
